import React, { useCallback } from 'react'
import FlexContainer from 'core-system/FlexContainer'
import Text from 'core-system/Text'
import Divider from 'core-system/Divider'
import IntegrateStripeBankAccount from 'features/Accounts/Payments/components/IntegrateStripeBankAccount'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/config/store'
import SegmentService from 'redux/config/services/SegmentService'
import PaymentMethod from 'features/Accounts/Payments/components/PaymentMethod'
import { useDispatch } from 'react-redux'
import { employerActions } from 'redux/employer/employerSlice'
import styled from 'styled-components'
import HeaderTextButton from 'core-system/ButtonV2/HeaderTextButton'
import { extraOnboardingCopy } from '../OnboardingUtils'
import PageWrapper from '../components/PageWrapper'
import { employerOnboardingStepData } from '../OnboardingUtils'
import RightImage from '../components/RightImage'
import { onboardingActions } from '../onboardingActions'
import { Locations } from 'shared/Router/Locations'
import { useNavigate } from 'react-router-dom'

const AddPaymentMethodButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`

const StripeSyncStage = React.memo(() => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const onboarding = useSelector((state: AppState) => state.onboarding)

  const { email, firstName, lastName } = useSelector(
    (state: AppState) => state.user.profile
  )
  const { platformFeeDetails } = useSelector(
    (state: AppState) => state.employer.profile
  )

  const handleDelete = useCallback(
    (id: string, type: string) => {
      dispatch(employerActions.removePaymentMethod(id))
      SegmentService.track('paymentMethod-btn-click', {
        action: 'delete',
        type,
      })
    },
    [dispatch]
  )

  const paymentMethodDetails = platformFeeDetails[0]

  const renderContent = () => (
    <>
      {platformFeeDetails?.length === 0 ? (
        <FlexContainer flexDirection='column'>
          <AddPaymentMethodButtonsContainer>
            <IntegrateStripeBankAccount
              billingEmail={email}
              billingName={`${firstName} ${lastName}`}
              CustomButton={HeaderTextButton}
              customButtonProps={{
                header: extraOnboardingCopy.addPayment.bankAccount.header,
                text: extraOnboardingCopy.addPayment.bankAccount.text,
                width: '100%',
              }}
              moveToNextStep={() => {
                dispatch(onboardingActions.updateOnboardingStage('ASYNC_ITEMS'))
                navigate(Locations.Dashboard)
              }}
            />
          </AddPaymentMethodButtonsContainer>
        </FlexContainer>
      ) : (
        <FlexContainer flexDirection='column'>
          <Divider marginBottom='2rem' />
          <Text variant='h5' marginBottom='1rem'>
            Your Added Payment Method
          </Text>
          <PaymentMethod
            id={paymentMethodDetails.internalId}
            type={paymentMethodDetails.type}
            bankName={paymentMethodDetails.bankName}
            brand={paymentMethodDetails.brand}
            last4={paymentMethodDetails.last4}
            expMonth={
              paymentMethodDetails.expMonth && paymentMethodDetails.expMonth
            }
            expYear={
              paymentMethodDetails.expYear && paymentMethodDetails.expYear
            }
            showActions={true}
            onDeleteAction={handleDelete}
          />
        </FlexContainer>
      )}
    </>
  )

  return (
    <PageWrapper
      title={employerOnboardingStepData.stripe.title}
      showBottomContainer={true}
      onboardingStage={onboarding.stage}
      leftContent={renderContent()}
      rightContent={<RightImage imageType='stripe' />}
    />
  )
})

// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  StripeSyncStage.displayName = 'StripeSyncStage'
}

export default StripeSyncStage
